<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Kidney Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="stagedKidney"
              disabled
              label="Staged Kidney"
              :class="{ highlightField: isDifferent(stagedKidney, stagedKidneyOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="stagedKidneyOATS"
              disabled
              label="Staged Kidney"
            />
          </div>
        </div>
      
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="kidneyPairedDonation"
              disabled
              label="Kidney Paired Donations"
              :class="{ highlightField: isDifferent(kidneyPairedDonation, kidneyPairedDonationOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="kidneyPairedDonationOATS"
              disabled
              label="Kidney Paired Donations"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="preEmptive"
              disabled
              label="Pre-Emptive"
              :class="{ highlightField: isDifferent(preEmptive, preEmptiveOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="preEmptiveOATS"
              disabled
              label="Pre-Emptive"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="listExchange"
              disabled
              label="List Exchange"
              :class="{ highlightField: isDifferent(listExchange, listExchangeOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="listExchangeOATS"
              disabled
              label="List Exchange"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="listExchangeDate"
              disabled
              label="List Exchange Date"
              :class="{ highlightField: isDifferent(listExchangeDate, listExchangeDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="listExchangeDateOATS"
              disabled
              label="List Exchange Date"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="previousLivingDonor"
              disabled
              label="Previous Living Donor"
              :class="{ highlightField: isDifferent(previousLivingDonor, previousLivingDonorOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="previousLivingDonorOATS"
              disabled
              label="Previous Living Donor"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
              :class="{ highlightField: isDifferent(serumCreatinine, serumCreatinineOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="serumCreatinineOATS"
              disabled
              label="Serum Creatinine"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
              :class="{ highlightField: isDifferent(serumCreatinineDate, serumCreatinineDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="serumCreatinineDateOATS"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>
<!--   
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="egfr"
              disabled
              label="EGFR"
              :class="{ highlightField: isDifferent(egfr, egfrOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="egfrOATS"
              disabled
              label="EGFR"
            />
          </div>
        </div> -->
  
        <!-- <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="egfrDate"
              disabled
              label="EGFR Date"
              :class="{ highlightField: isDifferent(egfrDate, egfrDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="egfrDateOATS"
              disabled
              label="EGFR Date"
            />
          </div>
        </div> -->
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="a1c"
                disabled
                label="A1C"
                :class="{ highlightField: isDifferent(a1c, a1cOATS) }"
              />
            </div>
            <div class="col-3">
              <ADSTextInput
                v-model="a1cOATS"
                disabled
                label="A1C"
              />
            </div>
          </div> -->
  
        <!-- <div class="row">
            <div class="col-3">
              <ADSTextInput
                v-model="a1cDate"
                disabled
                label="A1C Date"
                :class="{ highlightField: isDifferent(a1cDate, a1cDateOATS) }"
              />
            </div>
            <div class="col-3">
              <ADSTextInput
                v-model="a1cDateOATS"
                disabled
                label="A1C Date"
              />
            </div>
          </div> -->
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="generalComments"
              disabled
              label="General Comments"
              :class="{ highlightField: isDifferent(generalComments, generalCommentsOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="generalCommentsOATS"
              disabled
              label="General Comments"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="donationDate"
              disabled
              label="Donation Date"
              :class="{ highlightField: isDifferent(donationDate, donationDateOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="donationDateOATS"
              disabled
              label="Donation Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  
  export default {
    name: "KidneySpecificSectionDetails",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        stagedKidney: this.getStagedKidney( this.patientBundle ),
        kidneyPairedDonation: this.getKidneyPairedDonation( this.patientBundle ),
        preEmptive: this.getPreEmptive( this.patientBundle ),
        stagedKidneyOATS: this.getStagedKidneyOATS( this.patientBundleOATS, this.patientBundle ),
        kidneyPairedDonationOATS: this.getKidneyPairedDonationOATS( this.patientBundleOATS, this.patientBundle ),
        preEmptiveOATS: this.getPreEmptiveOATS( this.patientBundleOATS, this.patientBundle ),
        listExchange: this.getListExchange( this.patientBundle ),
        listExchangeOATS: this.getListExchangeOATS( this.patientBundleOATS, this.patientBundle ),
        listExchangeDate: this.getListExchangeDate( this.patientBundle ),
        listExchangeDateOATS: this.getListExchangeDateOATS( this.patientBundleOATS, this.patientBundle ),
        previousLivingDonor: this.getPreviousLivingDonor( this.patientBundle ),
        previousLivingDonorOATS: this.getPreviousLivingDonorOATS( this.patientBundleOATS, this.patientBundle ),
        serumCreatinine: this.getSerumCreatinine( this.patientBundle ),
        serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle )?.substring( 0,10 ),
        serumCreatinineOATS: this.getSerumCreatinineOATS( this.patientBundleOATS, this.patientBundle ),
        serumCreatinineDateOATS: this.getSerumCreatinineDateOATS( this.patientBundleOATS, this.patientBundle ),
        // egfr: this.getEGFR( this.patientBundle ),
        // egfrDate: this.getEGFRDate( this.patientBundle ),
        // egfrOATS: this.getEGFROATS( this.patientBundleOATS, this.patientBundle ),
        // egfrDateOATS: this.getEGFRDateOATS( this.patientBundleOATS, this.patientBundle ),
        a1c: this.getA1C( this.patientBundle ),
        a1cDate: this.getA1CDate( this.patientBundle ),
        generalComments: this.getGeneralComments( this.patientBundle ),
        a1cOATS: this.getA1COATS( this.patientBundleOATS, this.patientBundle ),
        a1cDateOATS: this.getA1CDateOATS( this.patientBundleOATS, this.patientBundle ),
        generalCommentsOATS: this.getGeneralCommentsOATS( this.patientBundleOATS, this.patientBundle ), 
        donationDate: this.getDonationDate( this.patientBundle ),
        donationDateOATS: this.getDonationDateOATS( this.patientBundleOATS, this.patientBundle ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      getSmartdataValue( patientBundle, observationCode ) {
        const entries = patientBundle?.entries;
        if( !entries?.length ) {
          return;
        }
        const smartdataGroups = entries.filter( ( n ) =>
          _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
        );
        const group = smartdataGroups[0];
        if( !group ) {
          return;
        }
        const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode &&
        _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if( !match[0] ) {
          return;
        }
        const component = _.get( match[0], 'resource.component[0]' );
        if( !component ) {
          return;
        }
        if( _.has( component, 'valueBoolean' ) ) {
          return component.valueBoolean ? 'Checked' : 'Unchecked';
        }
        if( component.valueString != null ) {
          return component.valueString;
        }
        if( component.valueDateTime != null ) {
          return component.valueDateTime;
        }
      },
      getEpisodePhase( patientBundle ) {
        if ( !patientBundle?.entries ) {
          return;
        }
        let episodeOfCares = patientBundle.entries.filter( ( n ) => (
          _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
        ) );
        if ( !( episodeOfCares?.[0]?.[0] ) ) {
          return;
        }
        const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
        if ( !( episodeOfCare ) ) {
          return;
        }
        const extensions = episodeOfCare?.[ 0 ]?.resource?.extension;
        if ( !extensions ) {
          return;
        }
        for ( const item of extensions ) {
          if ( item.url?.includes( 'transplant-phase-status' ) && item.extension?.length ) {
            const phaseExt = item.extension.filter( ( ext ) => ext.url === 'phase' );
            if ( phaseExt?.[0] ) {
              return _.get( phaseExt[0], 'valueCodeableConcept.coding[0].code' );
            }
          }
        }
      },
      getStagedKidney( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let stagedKidney = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#296' ) ) ;
      if( stagedKidney && stagedKidney[ 0 ] ) {
        return _.get( stagedKidney[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
      },
      getKidneyPairedDonation( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let kidneyPairedDonation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#297' ) ) ;
      if( kidneyPairedDonation && kidneyPairedDonation[ 0 ] ) {
        return _.get( kidneyPairedDonation[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
      },
      getPreEmptive( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let preEmptive = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#184' ) ) ;
      if( preEmptive && preEmptive[ 0 ] ) {
        return _.get( preEmptive[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
      },
      getStagedKidneyOATS( patientBundleOATS, patientBundle ) {
        let episodePhase = this.getEpisodePhase( patientBundle );
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) ); 
        let stagedKidney = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              stagedKidney = _.get( journey?.[ 0 ], 'organ_specific_details.staged_kidney', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              stagedKidney = _.get( journey?.[ 0 ], 'organ_specific_details.staged_kidney', '' );
            } 
          }
          if( journey.length === 1 ) {
          stagedKidney = journey[ 0 ].organ_specific_details?.staged_kidney;
          }
        }
        if( stagedKidney == null || stagedKidney === '' ) 
        return '';
        return stagedKidney ? 'Checked' : 'Unchecked';
      },
      getKidneyPairedDonationOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let kidneyPairedDonation = '';
        let episodePhase = this.getEpisodePhase( patientBundle );
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              kidneyPairedDonation = _.get( journey?.[ 0 ], 'recipient_programs.kidney_paired_donation', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              kidneyPairedDonation = _.get( journey?.[ 0 ], 'recipient_programs.kidney_paired_donation', '' );
            } 
          } 
          if( journey.length === 1 ) {
            kidneyPairedDonation = journey[ 0 ].recipient_programs?.kidney_paired_donation;
          }
        }
        if( kidneyPairedDonation == null || kidneyPairedDonation === '' ) 
        return '';
        return kidneyPairedDonation ? 'Checked' : 'Unchecked';
      },
      getPreEmptiveOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let preEmptive = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              preEmptive = _.get( journey?.[ 0 ], 'organ_specific_details.pre_emptive_gfr', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              preEmptive = _.get( journey?.[ 0 ], 'organ_specific_details.pre_emptive_gfr', '' );
            } 
          } 
          if( journey.length === 1 ) {
            preEmptive = journey[ 0 ].organ_specific_details?.pre_emptive_gfr;
          }
        }
        if( preEmptive == null || preEmptive === '' ) 
        return '';
        return preEmptive ? 'Checked' : 'Unchecked';
      },
      getListExchange( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let listExchange = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#299' ) ) ;
      if( listExchange && listExchange[ 0 ] ) {
        return _.get( listExchange[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
      },
      getListExchangeDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let listExchangeDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#300' ) ) ;
      if( listExchangeDate && listExchangeDate[ 0 ] ) {
        return _.get( listExchangeDate[ 0 ], 'resource.component[0].valueDateTime' )
      } 
      }
      },
      getListExchangeOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let listExchange = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              listExchange = _.get( journey?.[ 0 ], 'recipient_programs.list_exchange', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              listExchange = _.get( journey?.[ 0 ], 'recipient_programs.list_exchange', '' );
            } 
          } 
          if( journey.length === 1 ) {
            listExchange = journey[ 0 ].recipient_programs?.list_exchange;
          }
        }
        if( listExchange == null || listExchange === '' ) 
        return '';
        return listExchange ? 'Checked' : 'Unchecked';
      },
      getListExchangeDateOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let listExchangeDate = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              listExchangeDate = _.get( journey?.[ 0 ], 'recipient_programs.list_exchange_date', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              listExchangeDate = _.get( journey?.[ 0 ], 'recipient_programs.list_exchange_date', '' );
            } 
          } 
          if( journey.length === 1 ) {
            listExchangeDate = journey[ 0 ].recipient_programs?.list_exchange_date;
          }
        }
        if( listExchangeDate == null || listExchangeDate === '' ) 
        return '';
        return listExchangeDate;
      },
      getPreviousLivingDonor( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let previousLivingDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#301' ) ) ;
      if( previousLivingDonor && previousLivingDonor[ 0 ] ) {
        return _.get( previousLivingDonor[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
      } 
      }
      },
      getPreviousLivingDonorOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let previousLivingDonor = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              previousLivingDonor = _.get( journey?.[ 0 ], 'recipient_programs.previous_living_donor', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              previousLivingDonor = _.get( journey?.[ 0 ], 'recipient_programs.previous_living_donor', '' );
            } 
          } 
          if( journey.length === 1 ) {
            previousLivingDonor = journey[ 0 ].recipient_programs?.previous_living_donor;
          }
        }
        if( previousLivingDonor == null || previousLivingDonor === '' ) 
        return '';
        return previousLivingDonor ? 'Checked' : 'Unchecked';
      },
      containsCreatinine( observation ) {
       const data = observation.resource?.code?.coding?.filter( ( item ) => item.code === '14682-9' );
       if( data && data.length > 0 )
       return true;
      },
      getSerumCreatinine( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinine = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinine && serumCreatinine[ 0 ] ) {
        return _.get( serumCreatinine[ 0 ], 'resource.valueQuantity.value' );
      } 
      }
      },
      getSerumCreatinineDate( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinineDate = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinineDate && serumCreatinineDate[ 0 ] ) {
        return _.get( serumCreatinineDate[ 0 ], 'resource.issued' );
      } 
      }
      },
      getSerumCreatinineOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let serumCreatinine = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              serumCreatinine = _.get( journey?.[ 0 ], 'organ_specific_details.creatinine', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              serumCreatinine = _.get( journey?.[ 0 ], 'organ_specific_details.creatinine', '' );
            } 
          } 
          if( journey.length === 1 ) {
            serumCreatinine = journey[ 0 ].organ_specific_details?.creatinine;
          }
        }
        if( serumCreatinine == null || serumCreatinine === '' ) 
        return '';
        return serumCreatinine;
      },
      getSerumCreatinineDateOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let serumCreatinineDate = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              serumCreatinineDate = _.get( journey?.[ 0 ], 'organ_specific_details.creatinine_date', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              serumCreatinineDate = _.get( journey?.[ 0 ], 'organ_specific_details.creatinine_date', '' );
            } 
          } 
          if( journey.length === 1 ) {
            serumCreatinineDate = journey[ 0 ].organ_specific_details?.creatinine_date;
          }
        }
        if( serumCreatinineDate == null || serumCreatinineDate === '' ) 
        return '';
        return serumCreatinineDate;
      },
    //   getEGFR( patientBundle ) {
    //     return this.getSmartdataValue( patientBundle, 'SK#8062' );
    //   },
    //   getEGFRDate( patientBundle ) {
    //     return this.getSmartdataValue( patientBundle, 'SK#8063' );
    //   },
    //   getEGFROATS( patientBundleOATS, patientBundle ) {
    //     let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
    //     let episodePhase = this.getEpisodePhase( patientBundle );
    //     let EGFR = '';
    //     if( journey && journey[ 0 ] ) {
    //       if( journey.length > 1 ) {
    //         if( episodePhase > 30 ) {
    //           journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
    //           EGFR = _.get( journey?.[ 0 ], 'organ_specific_details.egfr', '' );
    //         } else {
    //           journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
    //           ( n.completed === false ) ) );
    //           EGFR = _.get( journey?.[ 0 ], 'organ_specific_details.egfr', '' );
    //         } 
    //       } 
    //       if( journey.length === 1 ) {
    //         EGFR = journey[ 0 ].organ_specific_details?.egfr;
    //       }
    //     }
    //     if( EGFR == null || EGFR === '' ) 
    //     return '';
    //     return EGFR;
    //   },
    //   getEGFRDateOATS( patientBundleOATS, patientBundle ) {
    //     let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
    //     let episodePhase = this.getEpisodePhase( patientBundle );
    //     let EGFRDate = '';
    //     if( journey && journey[ 0 ] ) {
    //       if( journey.length > 1 ) {
    //         if( episodePhase > 30 ) {
    //           journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
    //           EGFRDate = _.get( journey?.[ 0 ], 'organ_specific_details.egfr_date', '' );
    //         } else {
    //           journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
    //           ( n.completed === false ) ) );
    //           EGFRDate = _.get( journey?.[ 0 ], 'organ_specific_details.egfr_date', '' );
    //         } 
    //       } 
    //       if( journey.length === 1 ) {
    //         EGFRDate = journey[ 0 ].organ_specific_details?.egfr_date;
    //       }
    //     }
    //     if( EGFRDate == null || EGFRDate === '' ) 
    //     return '';
    //     return EGFRDate;
    //   },
      getA1C( patientBundle ) {
        return this.getSmartdataValue( patientBundle, 'SK#8064' );
      },
      getA1COATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let A1C = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              A1C = _.get( journey?.[ 0 ], 'organ_specific_details.a1c', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              A1C = _.get( journey?.[ 0 ], 'organ_specific_details.a1c', '' );
            } 
          } 
          if( journey.length === 1 ) {
              A1C = journey[ 0 ].organ_specific_details?.a1c;
          }
        }
        if( A1C == null || A1C === '' ) 
        return '';
        return A1C;
      },
      getA1CDate( patientBundle ) {
        return this.getSmartdataValue( patientBundle, 'SK#8065' );
      },
      getA1CDateOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let A1CDate = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              A1CDate = _.get( journey?.[ 0 ], 'organ_specific_details.a1c_date', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              A1CDate = _.get( journey?.[ 0 ], 'organ_specific_details.a1c_date', '' );
            } 
          } 
          if( journey.length === 1 ) {
            A1CDate = journey[ 0 ].organ_specific_details?.a1c_date;
          }
        }
        if( A1CDate == null || A1CDate === '' ) 
        return '';
        return A1CDate;
      },
      getGeneralComments( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let generalComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16531' ) ) ;
      if( generalComments && generalComments[ 0 ] ) {
        return _.get( generalComments[ 0 ], 'resource.component[0].valueString' );
      } 
      }
      },
      getGeneralCommentsOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let GeneralComments = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              GeneralComments = _.get( journey?.[ 0 ], 'comments', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              GeneralComments = _.get( journey?.[ 0 ], 'comments', '' );
            } 
          } 
          if( journey.length === 1 ) {
            GeneralComments = journey[ 0 ].comments;
          }
        }
        if( GeneralComments == null || GeneralComments === '' ) 
        return '';
        return GeneralComments;
      },
      getDonationDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let donationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#303' ) ) ;
      if( donationDate && donationDate[ 0 ] ) {
        return _.get( donationDate[ 0 ], 'resource.component[0].valueDateTime' )
      } 
      }
    },
    getDonationDateOATS( patientBundleOATS, patientBundle ) {
        let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 3 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
        let episodePhase = this.getEpisodePhase( patientBundle );
        let previousLivingDonationDate = '';
        if( journey && journey[ 0 ] ) {
          if( journey.length > 1 ) {
            if( episodePhase > 30 ) {
              journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
              previousLivingDonationDate = _.get( journey?.[ 0 ], 'recipient_programs.previous_living_donation_date', '' );
            } else {
              journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
              ( n.completed === false ) ) );
              previousLivingDonationDate = _.get( journey?.[ 0 ], 'recipient_programs.previous_living_donation_date', '' );
            } 
          } 
          if( journey.length === 1 ) {
            previousLivingDonationDate = journey[ 0 ].recipient_programs?.previous_living_donation_date;
          }
        }
        if( previousLivingDonationDate == null || previousLivingDonationDate === '' ) 
        return '';
        return previousLivingDonationDate;
      },
      isDifferent( a, b ) {
        return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
    },
    },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 560px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 1450px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    padding-top: 5px;
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  .highlightField :deep(.afflo-ds-form-control) {
    border: 2px solid red;
  }
  
  </style>
  